import AnimationRowSpritesheet from "./AnimationRowSpritesheet";
import OreSpriteOverlay from "./OreSpriteOverlay";
import SpriteAnimation from "./SpriteAnimation";
import SpriteAnimationManager from "./SpriteAnimationManager";
import TileDamageSpriteOverlay from "./TileDamageSpriteOverlay";
import TileDamageSpriteSeries from "./TileDamageSpriteSeries";

export default class TileOverlaySpritesheet extends AnimationRowSpritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     * @param {SpriteAnimationManager} spriteAnimationManager
     * @param {TileDamageSpriteOverlay} tileDamageSpriteOverlay
     * @param {OreSpriteOverlay} oreSpriteOverlay
     */
    constructor(fileName, spriteSize, spriteAnimationManager, tileDamageSpriteOverlay, oreSpriteOverlay) {
        super(fileName, spriteSize);

        /**
         * @type {SpriteAnimation}
         */
        this.upgradeSpriteOverlay = null;

        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;

        /**
         * @constant
         * @type {TileDamageSpriteOverlay}
         */
        this.tileDamageSpriteOverlay = tileDamageSpriteOverlay;

        /**
         * @constant
         * @type {OreSpriteOverlay}
         */
        this.oreSpriteOverlay = oreSpriteOverlay;

        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @override
     * @param {number} spriteSize
     * @returns {number}
     */
    calculateSpriteStep(spriteSize) {        
        return spriteSize + 1; // +1 because there is a 1px gap between sprites.
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        ///////////////////////////////////////////
        // Row 0: Platform animation
        ///////////////////////////////////////////

        // const platformSprites = this.parseRow(0, 8);
        // this.platformManager.plaformAnimation = new SpriteAnimation(platformSprites, this.spriteAnimationManager, false, false);

        ///////////////////////////////////////////
        // Row 0: Upgrade animation
        ///////////////////////////////////////////

        const upgradeSprites = this.parseRow(0, 2);
        this.upgradeSpriteOverlay = new SpriteAnimation(upgradeSprites, this.spriteAnimationManager, false, true);

        ///////////////////////////////////////////
        // Rows 1-3: Cracks
        ///////////////////////////////////////////

        const crackSprites0 = this.parseRow(1, 8);
        const damageSpriteSeries0 = new TileDamageSpriteSeries(crackSprites0);
        this.tileDamageSpriteOverlay.add(damageSpriteSeries0);

        const crackSprites1 = this.parseRow(2, 8);
        const damageSpriteSeries1 = new TileDamageSpriteSeries(crackSprites1);
        this.tileDamageSpriteOverlay.add(damageSpriteSeries1);

        const crackSprites2 = this.parseRow(3, 8);
        const damageSpriteSeries2 = new TileDamageSpriteSeries(crackSprites2);
        this.tileDamageSpriteOverlay.add(damageSpriteSeries2);

        ///////////////////////////////////////////
        // Row 4: Empty
        ///////////////////////////////////////////

        ///////////////////////////////////////////
        // Row 5-17: Ore
        ///////////////////////////////////////////

        this.oreSpriteOverlay.addSeries(this.parseRow(5, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(6, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(7, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(8, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(9, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(10, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(11, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(12, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(13, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(14, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(15, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(16, 8));
        this.oreSpriteOverlay.addSeries(this.parseRow(17, 8));


        this.loaded = true;
    }

}